/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoints, OAuth2Providers } from 'shared';

import { getApiEndpoint } from '../../utils/getApiEndpoint';

export const ssoLinks: Record<OAuth2Providers, string> = {
  github: getApiEndpoint(Endpoints.AuthenticationOauth2GitHubGet.route()),
  google: getApiEndpoint(Endpoints.AuthenticationOauth2GoogleGet.route()),
  microsoft: getApiEndpoint(Endpoints.AuthenticationOauth2MicrosoftGet.route()),
};
